'use strict';

module.exports = require('./is-implemented')()
	? Object.assign
	: require('./shim');



/*****************
 ** WEBPACK FOOTER
 ** /Users/bvaughn/Documents/git/react-devtools/~/es5-ext/object/assign/index.js
 ** module id = 13
 ** module chunks = 0
 **/